import { FormattedMessage } from "react-intl";
import { Button } from "@fluentui/react-components";

import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogBody,
} from "@fluentui/react-dialog";

import { DIALOG_ACTIONS } from "./messages";

export interface PostMeetingConfirmationProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export default function PostMeetingConfirmation({
  onConfirm,
  onCancel,
}: PostMeetingConfirmationProps) {
  return (
    <Dialog open modalType="alert" onOpenChange={onCancel}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            <FormattedMessage
              defaultMessage="Confirm Meeting Details"
              description="Title of the dialog asking the recruiter to confirm before saving the wrap-up form."
            />
          </DialogTitle>
          <DialogContent>
            <p>
              <FormattedMessage
                defaultMessage="By submitting, you confirm that you have reviewed and approved the meeting summary and extracted data for accuracy. This information will be added to the candidate's record in Connected. Do you want to proceed?"
                description="Body of the dialog asking the recruiter to confirm before saving the wrap-up form."
              />
            </p>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onConfirm}>
              <FormattedMessage {...DIALOG_ACTIONS.confirm} />
            </Button>
            <DialogTrigger>
              <Button appearance="secondary">
                <FormattedMessage {...DIALOG_ACTIONS.cancel} />
              </Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
